import React from "react";
import bg from "./images/background_1.jpg";
import logo from "./images/krone-white.svg";
import krone from "./images/krone-blue.svg";
import schwarzmueller from "./images/schwarzmueller.svg";
import preben from "./images/Preben Ferre.jpg";
import jan from "./images/Jan Bakken.jpg";
import christianna from "./images/Christianna Pappa.jpg";
import caretDown from "./images/caretdown.svg";
import "./App.css";
import Card from "./components/Card";

import { IoLogoFacebook } from "react-icons/io";

import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row } from "react-bootstrap";
import Person from "./components/Person";
import ProductBrand from "./components/ProductBrand";
import PhoneNumber from "./components/PhoneNumber";

function App() {
  return (
    <div className="App">
      <main>
        <div
          className="titleimage"
          style={{ position: "fixed", pointerEvents: "none", zIndex: "-10" }}
        >
          <div className="object-fit">
            <img src={bg} className="bg" alt="background" />
            <img
              src={logo}
              style={{
                position: "absolute",
                right: "50px",
                top: "30px",
                zIndex: 2,
                width: "250px",
              }}
              draggable="false"
              alt="logo"
            />
          </div>
        </div>

        <div
          style={{
            height: "calc(100svh)",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100%",
              textAlign: "center",
            }}
          >
            <Card>
              <h1>Velkommen til Krone Norge AS</h1>
              <p>Offisiell forhandler i Norge av</p>
              <p>
                <Container>
                  <Row style={{ alignContent: "baseline" }}>
                    <ProductBrand
                      image={krone}
                      alt="Krone logo"
                      url={"https://www.krone-trailer.com/en/"}
                    />
                    <ProductBrand
                      image={schwarzmueller}
                      alt="Schwarzmüller logo"
                      url={"https://schwarzmueller.com/en/"}
                    />
                  </Row>
                </Container>
              </p>
            </Card>

            <img
              src={caretDown}
              style={{
                zIndex: 2,
                opacity: "0.6",
                width: "80px",
                margin: "40px 0 10px 0",
              }}
              alt="caret"
            />
          </div>
        </div>

        <Card header="Hvem er vi?">
          <Container>
            <Row>
              <Col>
                <p>
                  Krone Norge AS er heleiet selskap av Krone Group, som holder
                  til på Gardermoen. Krone Norge AS ble etablert den 01.01.2024
                  som et resultat av en strategisk beslutning om å ha hånd om
                  hele salgskjeden.
                </p>
                <p>
                  Vi er hovedforhandler av trailere, tilhengere og vekselskap
                  fra Krone og Schwarzmüller. Krone Norge AS tilbyr salg av nye
                  og brukte trailere, samt leie gjennon Krone Fleet AS.
                </p>
              </Col>
            </Row>
          </Container>
        </Card>

        <Card header="Kontakt oss">
          <Container>
            <Row>
              <Col xs={12} md={4} className="mb-3">
                <Person
                  image={preben}
                  name="Preben Ferre"
                  email="preben.ferre@krone-trailer.no"
                  phone="(+47) 900 50 896"
                  roles={["Salg nytt", "Daglig leder"]}
                />
              </Col>
              <Col xs={12} md={4} className="mb-3">
                <Person
                  image={jan}
                  name="Jan Bakken"
                  email="jan.bakken@krone-trailer.no"
                  phone="(+47) 928 44 004"
                  roles={["Salg brukt", "Korttidsutleie"]}
                />
              </Col>
              <Col xs={12} md={4} className="mb-3">
                <Person
                  image={christianna}
                  name="Christianna Pappa"
                  email="christianna.pappa@krone-trailer.no"
                  phone="(+47) 461 23 338"
                  roles={["Salgsadministrasjon"]}
                />
              </Col>
            </Row>
          </Container>
        </Card>

        <Card header="Deler og verkstedstjenester">
          <Container>
            <Row>
              <Col xs={12}>
                Kontaktinformasjon vår partner for deler og verkstedtjenester
                hos <a href="https://www.vogn-service.no">Vogn-Service AS</a>:
              </Col>
              <Col xs={12} md={6} className="mb-3">
                <Person
                  name="Anders Bugten"
                  email="anders@vogn-service.no"
                  phone="(+47) 901 53 980"
                  roles={["Deler"]}
                />
              </Col>
              <Col xs={12} md={6} className="mb-3">
                <Person
                  name="Anders Axelsson"
                  email="andersa@vogn-service.no"
                  phone="(+47) 901 54 133"
                  roles={["Verkstedtjenester og garanti"]}
                />
              </Col>
            </Row>
          </Container>
        </Card>

        <Card header="Finn oss">
          <Container>
            <Row>
              <Col xs={12} lg={4}>
                <p>
                  Krone Norge AS
                  <br />
                  Gardermovegen 95 C
                  <br />
                  2030 Nannestad
                </p>
                <p>Org.nr.: 931 752 480 mva</p>
                <p>
                  Telefon: <PhoneNumber number={"(+47) 22 20 97 00"} />
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/kronetrailernorge/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <IoLogoFacebook size={48} />
                  </a>
                </p>
              </Col>
              <Col xs={12} lg={8}>
                <div style={{ width: "100%" }}>
                  <iframe
                    width="100%"
                    height="600"
                    title="Location"
                    src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=Gardermovegen%2095C,%202030%20Nannestad+(Krone%20Norge%20AS)&t=k&z=15&ie=UTF8&iwloc=B&output=embed"
                  ></iframe>
                </div>
              </Col>
            </Row>
          </Container>
        </Card>
      </main>
    </div>
  );
}

export default App;
